import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { SectionHeader, Pill } from "@/components/Brand";
import { ChevronRight, ArrowLeft } from "lucide-react";

export default function SurveyorBooths() {
  const { wardId } = useParams();
  const [ward, setWard] = useState(null);
  const [booths, setBooths] = useState([]);
  const nav = useNavigate();

  useEffect(() => {
    api.get("/surveyor/wards").then((r) => setWard(r.data.find((w) => w.id === wardId)));
    api.get(`/wards/${wardId}/booths`).then((r) => setBooths(r.data));
  }, [wardId]);

  return (
    <div>
      <Link to="/surveyor" className="inline-flex items-center gap-1 text-sm text-slate-600 mb-4 hover:text-slate-900">
        <ArrowLeft size={14} /> Back to wards
      </Link>
      <SectionHeader eyebrow={ward?.district || ""} title={`${ward?.name || ""} — Booths`} />
      <div className="space-y-3">
        {booths.map((b) => (
          <button
            key={b.id}
            onClick={() => nav(`/surveyor/wards/${wardId}/booths/${b.id}`)}
            data-testid={`surveyor-booth-${b.booth_number}`}
            className="w-full wi-card p-4 flex items-center justify-between hover:border-blue-300 wi-lift text-left"
          >
            <div>
              <div className="font-mono text-xs text-slate-500">Booth {b.booth_number}</div>
              <div className="font-semibold text-slate-900 mt-0.5">{b.polling_station}</div>
              <div className="text-xs text-slate-500">{b.area}</div>
            </div>
            <ChevronRight size={16} className="text-slate-400" />
          </button>
        ))}
        {booths.length === 0 && <div className="text-sm text-slate-500">No booths assigned yet.</div>}
      </div>
    </div>
  );
}
